import React, { useContext } from "react";
import commonContext from "../../../context/common";

function LoanConfirmationDetail() {
    const { utils, lead } = useContext(commonContext);
    return (
        <>
            <div className="container mx-auto px-0 md:px-5">
                <div className="loan-details w-full">
                    <div className="mb-8">
                        <h3 className="block px-5 py-4 md:py-4 px-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl">
                            Financial Details
                        </h3>
                        <div className="p-5 md:p-4 accord-content-bg leading-normal">
                            <ul className="flex flex-wrap justify-start lg:flex-row">
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        Loan Amount
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        <span className="WebRupee">Rs.</span>
                                        {utils.currencyFormat(lead.totalAmount)}
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        Your Contribution to Dealer
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        <span className="WebRupee">Rs.</span>
                                        {lead.marginMoneyPaid
                                            ? utils.currencyFormat(
                                                  lead.marginMoneyPaid
                                              )
                                            : "0"}
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        EMI
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        <span className="WebRupee">Rs.</span>
                                        {utils.currencyFormat(lead.emi)}
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        Interest Rate
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        {lead.interestRate}%
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        Tenure
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        {lead.liTenure} months
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        First EMI Due Date
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        {utils.getDateInFormat(
                                            lead.emiStartDate
                                        )}
                                    </p>
                                </li>
                                <li className="mb-3 md:mb-5 w-1/2 lg:w-3/12">
                                    <p className="openSans-Reg light-gray-1 text-xs md:text-base lg:text-base xl:text-base">
                                        Processing Fees
                                    </p>
                                    <p className="openSans-Reg text-black text-base sm:text-xl md:text-2xl">
                                        <span className="WebRupee">Rs.</span>
                                        {utils.currencyFormat(
                                            lead.processingFees
                                        )}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="mb-8">
                        <h3 className="block px-5 py-4 md:py-4 px-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl">
                            Vehicle Details
                        </h3>
                        <div className="p-5 md:p-4 accord-content-bg leading-normal">
                            <p className="openSans-Reg text-black mb-2 md:mb-2 xl:mb-5 text-2xl md:text-2xl lg:text-3xl xl:text-4xl w-full">
                                Vehicle Details
                            </p>
                            <ul className="flex flex-wrap justify-start flex-col md:flex-row">
                                <li className="mb-4 lg:mb-0 w-full md:w-1/2 xl:w-4/12">
                                    <p className="openSans-SemiBold text-black text-lg md:text-lg lg:text-2xl xl:text-3xl">
                                        {lead.manufacturer} {lead.make}{" "}
                                        {lead.model}
                                    </p>
                                    <p className="openSans-Reg grayshade-1 text-sm md:text-base lg:text-lg">
                                        From {lead.dealerAddress}
                                    </p>
                                </li>
                                <li className="mb-0 lg:mb-0 w-full md:w-1/2 xl:w-4/12">
                                    <p className="openSans-Reg grayshade-1 text-sm md:text-base lg:text-lg">
                                        Total On-road Cost
                                    </p>
                                    <p className="openSans-SemiBold text-black text-lg md:text-lg lg:text-2xl xl:text-3xl">
                                        <span className="WebRupee">Rs.</span>
                                        {utils.currencyFormat(
                                            lead.VDOnRoadCost
                                        )}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* <div className="mb-8">
                        <h3 className="block px-5 py-4 md:py-4 px-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl">
                            Dealer Details
                        </h3>
                        <div className="p-5 md:p-4 accord-content-bg leading-normal">
                            <p className="openSans-Reg grayshade-1 text-sm md:text-base lg:text-lg">
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum has been
                                the industry's standard dummy text ever since
                                the 1500s, when an unknown printer took a galley
                                of type and scrambled it to make a type specimen
                                book.
                            </p>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default LoanConfirmationDetail;
